<template>
  <el-table-column
    prop="customers"
    sortable="custom"
    label="Szállítás dátuma"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.delivery_date"
        style="display: inline;"
      >
        {{ scope.row.delivery_date | date }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customers',
};
</script>
